// eslint-disable-next-line @typescript-eslint/ban-types
export function mergeObjectsConcatValues(obj1: object, obj2: object): object {
  const keys = [...Object.keys(obj1), ...Object.keys(obj2)];
  const mergeResult = {};

  keys.forEach(key => {
    if (obj1[key] && obj2[key]) {
      mergeResult[key] = `${obj1[key]} ${obj2[key]}`;
    } else {
      mergeResult[key] = obj1[key] ?? obj2[key];
    }
  });

  return mergeResult;
}

export function hasOwnPropertyInsensitive(
  obj: Record<string, unknown>,
  key: string
): boolean {
  const asLowercase = key.toLowerCase();

  return !!Object.keys(obj).find(k => k.toLowerCase() === asLowercase);
}
